export default __webpack_public_path__ + "static/media/faq.340ad0e2.svg";